import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

// Etiqueta mono en mayúsculas, estilo HUD
const Eyebrow = ({ color, sx, children }) => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        fontFamily: theme.typography.fontFamilyMono,
        fontSize: 10,
        fontWeight: 600,
        letterSpacing: '0.16em',
        textTransform: 'uppercase',
        color: color || theme.palette.custom.inkDim,
        ...sx,
      }}
    >
      {children}
    </Box>
  )
}

export default Eyebrow
